import React from "react";
import { useTheme } from "@mui/material";
import TextInput from "./TextInput";

const TextFormInput = ({ formik, id, label, type = "text" }) => {
    const theme = useTheme();

    return (
        <TextInput
            id={id}
            label={label}
            type={type}
            value={Boolean(formik) ? (formik.values[id] ?? "") : ""}
            onChange={Boolean(formik) ? formik.handleChange : null}
            errorText={Boolean(formik) ? (formik.touched[id] && formik.errors[id]) : ""} 
        />
    );
};

export default TextFormInput;
